import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_WORKFLOW_TASK_TYPES } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { getField, updateField } from 'vuex-map-fields'

const workflowTaskTypes = {
  namespaced: true,
  state: buildInitialState({
    workflowTaskTypeList: []
  }),
  getters: { getField },
  actions: {
    getWorkflowTaskTypes ({ commit, state }) {
      if (state.workflowTaskTypeList.length > 0) {
        return Promise.resolve(state.workflowTaskTypeList)
      }

      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_WORKFLOW_TASK_TYPES })
        .then(json => json.data)
        .then(types => {
          commit('updateStatus', { status: COMPLETE })
          commit('setWorkflowTaskTypes', types)
          return types
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    }
  },
  mutations: {
    updateStatus,
    updateField,
    setWorkflowTaskTypes (state, types) {
      state.workflowTaskTypeList = types
    }
  }
}

export default workflowTaskTypes
